/* eslint-disable import/no-anonymous-default-export */
import axios from "../utils/axios";

class PaperBrokerSubmissionApi {
  async createSubmission(data: any) {
    const response = await axios.post(
      "/api/mortgageNotes/paperBrokerSubmission",
      data
    );
    return response.data;
  }
}

export default new PaperBrokerSubmissionApi();
